import { render } from "./OrdersRouter.vue?vue&type=template&id=5ac555e9&scoped=true"
import script from "./OrdersRouter.vue?vue&type=script&lang=js"
export * from "./OrdersRouter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5ac555e9"

export default script